import { graphql } from '@client/graphql/types';
import { useMutation } from '@apollo/client';

export const MUTATION = graphql(`
  mutation DeleteHappyHour($id: ID!) {
    deleteHappyHour(id: $id) {
      id
    }
  }
`);

export default function useDeleteHappyHour() {
  return useMutation(MUTATION, {
    refetchQueries: ['GetHappyHours'],
  });
}
